import { useEffect, useRef, useState } from "react";

// Shared by the standalone lead-magnet pages (Call, Demo) that embed a
// Calendly inline widget the same way: try the widget, fall back to a
// direct link if it hasn't loaded within 8s.
const CalendlyEmbed = ({ url, className = "lead-calendly" }) => {
    const containerRef = useRef(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const widgetUrl = `${url}${url.includes("?") ? "&" : "?"}hide_gdpr_banner=1&primary_color=e67700`;

        const widget = document.createElement("div");
        widget.className = "calendly-inline-widget";
        widget.setAttribute("data-url", widgetUrl);
        widget.style.minWidth = "280px";
        widget.style.height = "700px";
        container.appendChild(widget);

        const script = document.createElement("script");
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        script.onerror = () => setFailed(true);
        document.body.appendChild(script);

        const timer = setTimeout(() => {
            if (!widget.querySelector("iframe")) setFailed(true);
        }, 8000);

        return () => {
            clearTimeout(timer);
            document.body.removeChild(script);
        };
    }, [url]);

    if (failed) {
        return (
            <div className={className}>
                <div className="lead-embed__fallback">
                    <p>The scheduler didn't load.</p>
                    <a href={url} target="_blank" rel="noopener noreferrer">Book directly on Calendly instead</a>
                </div>
            </div>
        );
    }

    return <div className={className} ref={containerRef} />;
};

export default CalendlyEmbed;
